import React from 'react'
import Header from '../Components/Header/Header'

const HeaderView = () => {
  return (
    <div>
        <Header />
    </div>
  )
}

export default HeaderView